import React, {FC} from 'react';

import {withSitecoreContext} from '@sitecore-jss/sitecore-jss-react';
import {LayoutSeoTagModel} from './model/layoutSeoTags.model';
import {TLayoutSeoTagsProps} from './types/layoutSeoTags.types';
import SeoTags from '../seoTags';

const LayoutSeoTags: FC<TLayoutSeoTagsProps> = (props) => {
  const model = new LayoutSeoTagModel(props);

  return (<SeoTags model={model}/>)
}

export default withSitecoreContext()(LayoutSeoTags);